import React from "react"
import styled from "styled-components"
import { Grid } from "../../atoms/grid"
import { Card } from "../../molecules/card"
import { Link } from "gatsby"

import { Settings } from "../../../styles/theme"

import { Advertisement } from "../advertisement"

const Imagepattern = styled.div`
  position: relative;
  padding: 2rem 0;
  .bg,
  img {
    margin: 0;
    width: 100%;
  }
  .bg {
    position: absolute !important;
    top: 0;
    left: 0;
    z-index: 0;
    filter: brightness(0.3);
    @media screen and (max-width: ${Settings.sizeL}) {
      min-height: 100%;
      height: 100%;
    }
  }
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: #fff;
  }
  .content {
    position: relative;
    z-index: 1;
    padding: 1rem 2rem;
    max-width: 480px;
  }
  .col {
    position: relative;
  }
  .col:first-of-type {
    .content {
      text-align: right;
      margin-left: auto;
    }
  }
  > div {
    align-items: stretch;
  }
  h4 {
    font-size: 1.2rem;
    font-weight: 700;
    margin-top: 0;
  }
`

export const ImageDiv = ({ children, columns }) => (
  <Imagepattern>
    <Grid columns={columns}>{children}</Grid>
  </Imagepattern>
)

const Simplemasonrystyled = styled.div`
  position: relative;
  p {
    font-size: 0.9rem;
  }
  > div {
    > div {
      flex: ${props => (props.off ? "1 1 25%" : "1 1 30%")};
      > div {
        padding: 0.5rem;
        > a {
          > div {
            transition: all 175ms ease-in-out;
            &:hover {
              transform: scale(1.04);
              box-shadow: 8px 8px 8px rgba(0, 0, 0, 0.2);
            }
            @media screen and (max-width: ${Settings.sizeM}) {
              height: 300px !important;
            }
          }
        }
      }
      &:first-of-type {
        flex: ${props => (props.off ? "1 1 45%" : "1 1 30%")};
      }
      @media screen and (max-width: ${Settings.sizeM}) {
        flex: 1 1 100% !important;
      }
    }
  }
`

export const SimpleMasonry = ({ data, images, off }) => (
  <Simplemasonrystyled off={off}>
    <Grid>
      {data.length > 1 ? (
        <div>
          {data.slice(0, 2).map((item, i) => (
            <div>
              <Link to={item.slug}>
                <Card height="265px" key={i} fluid={images[i]}>
                  <h4 className="white">{item.title}</h4>
                  <p className="white">{item.description}</p>
                </Card>
              </Link>
            </div>
          ))}
        </div>
      ) : (
        <h4>There are no items</h4>
      )}
      {data.length > 2 ? (
        <div>
          <div style={{ padding: "0 0.5rem" }}>
            <Link to={data[2].slug}>
              <Card height="555px" fluid={images[2]}>
                <h4 className="white">{data[2].title}</h4>
                <p className="white">{data[2].description}</p>
              </Card>
            </Link>
          </div>
        </div>
      ) : (
        ""
      )}
      {data.length > 3 ? (
        <div>
          <div>
            <Link to={data[3].slug}>
              <Card height="330px" fluid={images[3]}>
                <h4 className="white">{data[3].title}</h4>
                <p className="white">{data[3].description}</p>
              </Card>
            </Link>
          </div>
          <div>
            <Link to={data[4].slug}>
              <Card height="200px" fluid={images[4]}>
                <h4 className="white">{data[4].title}</h4>
                <p className="white">{data[4].description}</p>
              </Card>
            </Link>
          </div>
          {/*
          {advertisement ? (
            <div style={{ margin: "5px" }}>
              <Advertisement
                advertisements={advertisement.advertisements}
                advertisementMobile={advertisement.advertisementMobile}
                height={"200px"}
                mobileHeight={"100px"}
              />
            </div>
          ) : (
            <div>
              
                <Card height="235px" fluid={images[4]} />
              
            </div>
          )}
          */}
        </div>
      ) : (
        ""
      )}
    </Grid>
  </Simplemasonrystyled>
)

const Pairedstyled = styled.div`
  background: ${props => (props.background ? props.background : "none")};
  h5 {
    > a {
      position: relative;
      padding: 1rem 1.5rem;
      border: 1px transparent;
      font-size: 1rem;
      border-radius: 5px;
      font-weight: 700;
      text-decoration: none;
      cursor: pointer;
      color: ${Settings.primaryColor};
      background: ${Settings.primaryColor};
      color: #fff;
    }
  }
  > div {
    position: relative;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin: ${props => (props.background ? "0 auto" : "3rem auto")};
    padding: ${props => (props.background ? "3rem 0" : "0")};
    flex-wrap: wrap;
    > div:nth-of-type(even) {
      flex: 1 1 35%;
    }
    > div:nth-of-type(odd) {
      flex: 1 1 55%;
    }
    > div {
      margin: 0 2%;
      @media screen and (max-width: ${Settings.sizeM}) {
        flex: 1 1 100% !important;
      }
    }
  }
  &:nth-of-type(odd) {
    > div {
      flex-direction: row-reverse;
    }
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${Settings.primaryColor};
  }
  .gatsby-image-wrapper {
    cursor: pointer;
  }
  .dropdown {
    li {
      height: 0;
      opacity: 0;
      transition: all 125ms ease-in-out;
    }
    h6 {
      position: relative;
      margin-bottom: 0;
      &:after {
        position: absolute;
        content: ">";
        top: 0;
        left: -1rem;
        font-weight: 300;
        color: ${Settings.primaryColor};
      }
    }
  }
  .dropdown.active {
    h6 {
      color: ${Settings.primaryColor};
      transform: scale(1.25);
      transform-origin: center left;
    }
    li {
      height: 100%;
      opacity: 1;
    }
  }
  ul:not(.dropdown) {
    li {
      position: relative;
      &:after {
        content: ">";
        color: ${Settings.primaryColor};
        font-weight: 700;
        position: absolute;
        top: 0;
        left: -1rem;
      }
    }
  }
  ul.dropdown > h6 {
    cursor: pointer;
  }
  ul {
    list-style-type: none;
    padding: 0;
    ul {
      padding-left: 1.5rem;
    }
  }
  .carousel {
    position: relative;
    .arrow {
      opacity: 0;
      transition: all 125ms ease-in-out;
      pointer-events: none;
    }
    .arrow.show {
      opacity: 1;
      pointer-events: all;
    }
    b {
      color: ${Settings.primaryColor};
      position: absolute;
      font-size: 2rem;
      top: 50%;
      transform: translateY(-35%);
      z-index: 99;
      cursor: pointer;
      &:first-of-type {
        left: -2rem;
      }
      &:last-of-type {
        right: -2rem;
      }
    }
    .inner {
      white-space: nowrap;
      overflow: hidden;
      .image {
        width: 30%;
        height: 100px;
        display: inline-block;
        padding-top: 1rem;
        transition: all 275ms ease-in-out;
        transform: translateX(
          ${props => (props.push ? props.push * -333 : 0)}%
        );
        .gatsby-image-wrapper {
          height: 100px;
        }
      }
      .middle {
        margin: 0 5%;
      }
    }
  }
`

export const Paired = ({ children, push, background }) => (
  <Pairedstyled push={push} background={background}>
    <div className="constraint">{children}</div>
  </Pairedstyled>
)

const PairedRepeatStyled = styled.div`
  > div {
    position: relative;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin: 2rem auto;
    flex-wrap: wrap;
    ${props =>
      props.newsbyte
        ? `
    &:not(:first-of-type) {
      border-top: 1px solid rgba(0, 0, 0, 0.3);
      padding-top: 1rem;
    }
    `
        : ""}
    > div:nth-of-type(even) {
      flex: 1 1 60%;
    }
    > div:nth-of-type(odd) {
      flex: 1 1 30%;
    }
    > div {
      margin: 0 2%;
      @media screen and (max-width: ${Settings.sizeM}) {
        flex: 1 1 100% !important;
      }
    }
    &:nth-of-type(even) {
      flex-direction: row-reverse;
    }
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      color: ${Settings.primaryColor};
    }
    h6 {
      margin: 0;
    }
  }
`

export const PairedRepeat = ({ children, newsbyte }) => (
  <PairedRepeatStyled className="constraint" newsbyte={newsbyte}>
    {children}
  </PairedRepeatStyled>
)

const PairedDoubleRepeatStyled = styled.div`
  display: flex;
  align-items: flex-start;
  position: relative;
  justify-content: space-between;
  > div {
    flex: 1 1 50%;
    position: relative;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin: 1rem auto;
    flex-wrap: wrap;
    > div:nth-of-type(even) {
      flex: 1 1 60%;
    }
    > div:nth-of-type(odd) {
      flex: 1 1 30%;
    }
    > div {
      margin: 0 2%;
      @media screen and (max-width: ${Settings.sizeM}) {
        flex: 1 1 100% !important;
      }
    }
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      color: ${Settings.primaryColor};
    }
    h6 {
      margin: 0;
    }
  }
`

export const PairedDoubleRepeat = ({ children }) => (
  <PairedDoubleRepeatStyled className="constraint">
    {children}
  </PairedDoubleRepeatStyled>
)

const Numberedstyle = styled.div`
  position: relative;
  &:nth-of-type(1) {
    &:after {
      content: "1";
      position: absolute;
      font-size: 100px;
      top: 0;
    }
  }
  &:nth-of-type(2) {
    content: "2";
  }
  &:nth-of-type(3) {
    content: "3";
  }
  .flex {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-weight: 700;
    }
    p {
      margin: 0;
    }
    h4 {
      color: ${Settings.primaryColor};
    }
    > div {
      flex: 0 0 30%;
      margin: 1rem;
      position: relative;
      text-align: left;
      .ident {
        font-size: 10rem;
        font-weight: 700;
        color: ${Settings.secondaryColor};
        position: absolute;
        margin: 0;
        top: 45%;
        transform: translateY(-50%);
        opacity: 0.34;
        z-index: -1;
        left: -2rem;
      }
      @media screen and (max-width: ${Settings.sizeM}) {
        flex: 1 1 100%;
      }
    }
  }
`

export const Numbered = ({ children }) => (
  <Numberedstyle className="constraint">{children}</Numberedstyle>
)

const ImageWithLinkStyle = styled.div`
  position: relative;
  .gatsby-image-wrapper {
    min-height: 150px !important;
    max-height: 250px !important;
  }
`

export const ImageWithLink = ({ children }) => (
  <ImageWithLinkStyle>{children}</ImageWithLinkStyle>
)

export const ThreeColumns = styled.div`
  position: relative;
  text-align: left;
  h5,
  h6 {
    color: ${Settings.primaryColor};
    font-weight: 700;
    font-size: 1rem;
    text-align: left;
  }
  h6 {
    font-size: 0.9rem;
    color: #000;
    font-weight: 300;
    margin: 0;
  }
  h4 {
    color: ${Settings.primaryColor};
    font-weight: 700;
    font-size: 3rem;
    margin-bottom: 0;
    margin-top: 1rem;
  }
  h3,
  h2,
  h1 {
    color: ${Settings.primaryColor};
  }
  p {
    font-size: 0.9rem;
    margin-top: 0;
    color: ${Settings.greyColor};
  }
  img,
  .gatsby-image-wrapper {
    padding-top: 1rem;
    max-width: none !important;
    width: 100%;
  }
  > div {
    align-items: flex-start;
  }
  a {
    color: ${Settings.secondaryColor};
  }
`
